import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../assets/css/slider.css';
import '../assets/css/owlcarousel.css';
import SliderMain from '../common/slider/SliderMain';
import OwlCarouselHome from '../common/owlcarousel/OwlCarouselHome';
const Layout = () => {
  return (
  <div>
		{/* <!-- HEADER START --> */}
			<Header length='40' headerStyle="header-style-4" mainBarBackground="bg-white" siteBackground="site-bg-primary" />
		{/* <!-- HEADER END --> */}
		
		{/* <!-- SLIDER START --> */}
			<section className="section homepage-add-section" id="sliderSection">
				<SliderMain />
			</section>
		{/* <!-- SLIDER END --> */}
		
		{/* <!-- OWL CAROUSEL START --> */}
			<section className="section homepage-add-section" id="carouselSection">
				<OwlCarouselHome/>	
			</section>
		{/* <!-- OWL CAROUSEL END --> */}
		
		{/* <!-- CONTENT PART START --> */}
		<div className="content">
			<Outlet />
		</div>
		{/* <!-- CONTENT PART END --> */}		
    <Footer />
  </div>
  );
};
export default Layout;